define.alias("shared/components/shared/button/boost", "calendar/components/shared/button/boost");